import { Select, MenuItem } from "@mui/material";
import addMonths from "date-fns/addMonths";
import format from "date-fns/format";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import { useIsMobile } from "../../../hooks/useIsMobile";

const now = new Date();

const MonthPicker = ({
  value,
  setValue,
  type,
  disabled,
}: {
  value: string;
  setValue: (value: string) => void;
  type: "start" | "end";
  disabled?: boolean;
}) => {
  const isMobile = useIsMobile(400);

  return (
    <Select
      size="small"
      fullWidth
      sx={{ fontSize: isMobile ? 12 : 14 }}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      disabled={disabled}
    >
      {Array.from({ length: 12 }).map((_, i) => {
        const date =
          type === "start"
            ? startOfMonth(addMonths(now, i))
            : endOfMonth(addMonths(now, i));
        return (
          <MenuItem key={date.toISOString()} value={format(date, "yyyy-MM-dd")}>
            {format(date, "MMM yyyy")}
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default MonthPicker;
